import React from 'react';
import PropTypes from 'prop-types';
import APIKeys from './APIKeys';
import ACLList from './ACLList';
import CircularProgress from 'material-ui/CircularProgress';
import queries from '../../graphql/queries';
import ItemListDefaultTemplate from './ItemListDefaultTemplate';
import { GraphQLStackTrace } from "../../utils/utils";
import { compose } from 'react-apollo';
import './ProjectSettings.css';

class ProjectSettings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        if (this.props.data.loading) {
            return (
                <CircularProgress className="activityIndicator"/>
            )
        } else if (this.props.data.error) {
            return <pre>{GraphQLStackTrace(this.props.data.error)}</pre>;
        }
        return (
            <div className="project-settings">
                <div className="card">
                    <h3>Project API Keys</h3>
                    <APIKeys project={this.props.data.project}/>
                </div>
                {this.props.data.project.aclRole === "admin" &&
                <div className="card">
                    <h3>User Permissions</h3>
                    <ACLList project={this.props.data.project}/>
                </div>
                }
                <div className="card">
                    <h3>Items List Default Template</h3>
                    <ItemListDefaultTemplate project={this.props.data.project}/>
                </div>
            </div>
        );
    }

}

ProjectSettings.propTypes = {
    data: PropTypes.object.isRequired
};

ProjectSettings.defaultProps = {};

export default compose(
    queries.projectQueryHoc
)(ProjectSettings);



// WEBPACK FOOTER //
// ./src/components/projectSettings/ProjectSettings.js